import { render, staticRenderFns } from "./ForGlobalSellers.vue?vue&type=template&id=1c2fceb6"
import script from "./ForGlobalSellers.vue?vue&type=script&lang=js"
export * from "./ForGlobalSellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports